import React from 'react'

function Solutions() {
  return (
    <div>Solutions</div>
  )
}

export default Solutions